module.exports = __webpack_public_path__ + "static/media/1.matboardSizingAndArtworkWindowOptions.1d2183ac.webp";